import React from 'react';
import { ToastBar, toast } from 'react-hot-toast';
import { X, AlertCircle, CheckCircle2 } from 'lucide-react';

const CustomToast = (t) => {
  const isError = t.type === 'error';
  const isSuccess = t.type === 'success';
  const msg = typeof t.message === 'string' ? t.message : String(t.message || '');
  const isNetworkError = isError && /network/i.test(msg);

  const displayMessage = isNetworkError ? 'Refrescá la página nuevamente 🔄' : msg;
  const bgColor = isNetworkError
    ? '#F59E0B'
    : isError
    ? '#F44336'
    : isSuccess
    ? '#4CAF50'
    : '#363636';
  const Icon = isError
    ? AlertCircle
    : isSuccess
    ? CheckCircle2
    : null;

  return (
    <ToastBar
      toast={t}
      style={{
        background: bgColor,
        color: 'white',
        boxShadow: '0 4px 6px rgba(0,0,0,0.1)',
      }}
    >
      {() => (
        <div className="flex items-start justify-between w-full gap-2">
          <div className="flex items-center gap-2">
            {Icon && <Icon className="w-5 h-5 shrink-0" />}
            <span className="text-sm">{displayMessage}</span>
          </div>
          <button onClick={() => toast.dismiss(t.id)} className="cursor-pointer">
            <X className="w-4 h-4 opacity-80 hover:opacity-100" />
          </button>
        </div>
      )}
    </ToastBar>
  );
};

export default CustomToast;
